export const SET_SUBMITTING = "submittingChanges/SET_SUBMITTING";

export const setSubmittingChanges = (isSubmitting?: boolean) => ({
  type: SET_SUBMITTING,
  payload: { isSubmitting },
});
